import React, { useEffect, useState } from "react";
import BaseTable from "../../Components/Common/BaseTable"; 
import BaseButton from "../../Components/Common/BaseButton"; 
import { mdiPlus } from '@mdi/js';
import Icon from '@mdi/react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; 
import { REQUEST_DELETE_SERVICE_COMMON, REQUEST_LIST_OF_SERVICES_COMMON } from "API/Services/common"; 
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap"; 
import { checkStatusCodeSuccess } from "Components/constants/enums";
import { ACTION_HEADER, ACTIONS_ACCESSOR, ADD_LABEL, ARE_YOU_SURE_DELETE, CANCEL_LABEL, DELETE_CAPI, DELETE_LABEL, EDIT_CAPI, ID_ACCESSOR, SEARCH_INQUIRIES, SERIAL_NO, SERVICE_TITLE, SERVICENAME_ACCESSOR, SERVICENAME_HEADER, SERVICES_LABEL } from "Components/constants/commonNames";
import { RiSearchLine } from "react-icons/ri";

interface Service {
  id: number;
  service_name: string; 
}

interface PaginationInfo {
  totalPages: number;
  totalRecordsCount: number;
  currentPage: number;
  numberOfRows: number | any;
}

const ListOfServicesPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [services, setServices] = useState<Service[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [fullScreenLoader, setFullScreenLoader] = useState(false);
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [modal, setModal] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState<Service | null>(null);
  const navigate = useNavigate();
  const [paginationInfo, setPaginationInfo] = useState<PaginationInfo>({
    totalPages: 1,
    totalRecordsCount: 0,
    currentPage: 1,
    numberOfRows: 10, 
  });

  const columns = [
    {
      enableColumnFilter: false,
      accessorKey: ID_ACCESSOR,
      header: SERIAL_NO,
      cell: ({ row }: any) => row.index + 1,
    },
    {
      enableColumnFilter: false,
      accessorKey: SERVICENAME_ACCESSOR,
      header: SERVICENAME_HEADER,
    },
    {
      id: ACTIONS_ACCESSOR,
      header: ACTION_HEADER,
      cell: ({ row }: any) => (
        <div className="d-flex">
          <i 
            className="text-info mdi mdi-pencil cursor-pointer fs-4"
            onClick={() => navigate(`/edit-service/${row.original.id}`)}
            title={EDIT_CAPI}
          />
          <i
            className="text-danger mdi mdi-delete cursor-pointer fs-4"
            onClick={() => confirmDelete(row.original)}
            title={DELETE_CAPI}
          />
        </div>
      ),
    },
  ];

  const payload = {
    searchBar: searchValue,
    sortKey: columnName,
    sortValue: sortOrder,
    pageSize: pageSize,
    page: page,
  };

  const fetchServices = async () => {
    setFullScreenLoader(true); 
    try {
        const response = await REQUEST_LIST_OF_SERVICES_COMMON(payload);

        if (checkStatusCodeSuccess(response?.statusCode)) {
            setServices(response.data.listOfServiceName);
            setPaginationInfo({
              totalPages: response.data.totalPages,
              totalRecordsCount: response.data.totalRecordsCount,
              currentPage: response.data.currentPage,
              numberOfRows: response.data.numberOfRows
            });
        } else {
          setPaginationInfo(prev => ({
            ...prev,
            numberOfRows: 0,
          }));
        }
    } catch (error :any) {
        toast.error(error?.response?.data?.message || error.message);
    } finally {
        setFullScreenLoader(false); 
    }
};




  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1);
  };


  const handleSearch = (value: string) => {
    if (value !== searchValue) {
      setPage(1);
      setSearchValue(value);
    }
  };
  const handleSort = (column: string, direction: 'asc' | 'desc') => {
    setColumnName(column);
    setSortOrder(direction);
    setPage(1);
  };


  const confirmDelete = (service: Service) => {
    setServiceToDelete(service);
    toggleModal();
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const updateServiceStatus = async () => {
    if (serviceToDelete) {
      toggleModal();
    setFullScreenLoader(true); 
      
      try {
        const response = await REQUEST_DELETE_SERVICE_COMMON(serviceToDelete.id);
  
        if (checkStatusCodeSuccess(response?.statusCode)) {
          toast.success(response?.message);
          setServices(services.filter(service => service.id !== serviceToDelete.id));
        } else {
          toast.error(response?.message);

        }
      } catch (error: any) {
        toast.error(error.response?.data?.message || error.message);
      } finally {
        setFullScreenLoader(false); 
        setServiceToDelete(null);
      }
    }
  };
  

  useEffect(() => {
    fetchServices();

  }, [searchValue, columnName, sortOrder, pageSize, page]);

  document.title = SERVICE_TITLE;


  return (
    <div className="top-div">
      <div className="mx-4">
        <div className="d-flex justify-content-between align-items-center mb-1 mt-2">
          <span className="fs-4 mx-2">{SERVICES_LABEL}</span>
          <BaseButton
            onClick={() => navigate("/add-service")}
            className="mt-0 w-auto px-4 py-2"
            color="info"
            text={<>
              <Icon path={mdiPlus} size={0.8} className="me-2"/>
            {ADD_LABEL}
            </>}
          />
        </div>

        <div className="card">
          <div className="card-body">
            {loading ? (
              <div className="loading-overlay">
                <div className="spinner"></div>
              </div>
            ) : (

              
              <BaseTable
              columns={columns}
              data={services}
              isGlobalFilter={true}
              customPageSize={pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              onSearch={handleSearch}
              onSort={handleSort}
              tableClass="table bg-white"
              divClass="text-nowrap"
              manualPagination={true}
              tableLoader={loader}
              currentPage={paginationInfo.currentPage}
              totalPages={paginationInfo.totalPages}
              totalRecords={paginationInfo.totalRecordsCount}
              SearchPlaceholder={SEARCH_INQUIRIES}
              numberOfRows={paginationInfo.numberOfRows}
            />
            )}
          </div>
        </div>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className="modal-dialog-centered modal-md"
      >
        <ModalHeader toggle={toggleModal}>{DELETE_LABEL}</ModalHeader>
        <ModalBody>
          <p>{ARE_YOU_SURE_DELETE}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={updateServiceStatus}>
            {DELETE_LABEL}
          </Button>
          <Button color="danger" onClick={toggleModal}>
            {CANCEL_LABEL}
          </Button>
        </ModalFooter>
      </Modal>

      {fullScreenLoader && (
          <div className="full-screen-loader">
            <Spinner />
          </div>
        )}
    </div>
  );
};

export default ListOfServicesPage;
